export enum DetectionLifecycleState {
  ACTIVE = "active",
  RESOLVED = "resolved",
  EXPIRED = "expired",
  SUPERSEDED = "superseded",
  // Its rule no longer selects it: it leaves the board and the score.
  RETRACTED = "retracted",
}

export const dataByDetectionLifecycleState: Record<
  DetectionLifecycleState,
  { label: string }
> = {
  [DetectionLifecycleState.ACTIVE]: { label: "Active" },
  [DetectionLifecycleState.RESOLVED]: { label: "Resolved" },
  [DetectionLifecycleState.EXPIRED]: { label: "Expired" },
  [DetectionLifecycleState.SUPERSEDED]: { label: "Superseded" },
  [DetectionLifecycleState.RETRACTED]: { label: "Retracted" },
}
